import { PublicPage } from '../base.js';
import { AppConfig } from '../../config.js';

export class ForgotPassword extends PublicPage {
  static timl = `
    section.auth-page[aria-labelledby="forgot-password-title"]
      form.stacked-form.auth-form[action="${AppConfig.authServiceApiBaseUrl}/en/1/reset-password" onSuccessRedirect="/password-reset" method="POST"]
        header.auth-header
          h1#forgot-password-title Forgot your password?
          p Enter the email associated with your account and we'll send you a reset link.
        .auth-fields
          label.auth-field
            span Email address
            input[name="email" type="email" autocomplete="email" placeholder="you@example.com" required="true"]
        .auth-submit-row
          button.auth-primary[type="submit"] Send reset link
        .auth-divider[aria-hidden="true"]
          span or
        p.auth-switch
          span Remember your password?
          a[href="/login"] Log in
  `;
}
